module.exports = __webpack_public_path__ + "static/media/research-10.5c0000d8.svg";